import {memo} from 'react'
import LocationMarkerIcon from '../../images/svg/LocationMarker'
import {KegLocation} from '../../types'

const kegLocations: KegLocation[] = [
  'Inside' as KegLocation,
  'Out the Front' as KegLocation,
  'Out the Back' as KegLocation,
]

const getKegLocationDescription = (location: KegLocation) => {
  return location === 'Inside'
    ? 'Any additional instructions on access please include in the notes.'
    : 'Please only select if accessible outside of business hours. Any additional instructions on access please include in the notes.'
}

interface KegLocationRadioCardsProps {
  onClick: (location: KegLocation) => void
  kegLocation: KegLocation
  isDisabled?: boolean
}

const KegLocationRadioCards = ({
  onClick,
  kegLocation,
  isDisabled = false,
}: KegLocationRadioCardsProps) => {
  return (
    <div className="mb-5">
      <label className="block mb-2 text-xs text-sky-500 dark:text-sky-400">Keg Location</label>
      <div
        className="flex gap-2"
        role="group"
        aria-label="Keg Location"
      >
        {kegLocations.map((value) => (
          <button
            type="button"
            className={[
              'flex items-center justify-center flex-col gap-1',
              'w-1/3 p-2 rounded-sm',
              'border border-gray-300 dark:border-slate-600 focus:border-sky-500 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-1 dark:focus:ring-offset-slate-900',
              'disabled:opacity-50 disabled:cursor-not-allowed',
              value === kegLocation ? 'bg-sky-500 dark:bg-sky-600' : 'bg-transparent',
            ].join(' ')}
            onClick={() => onClick(value)}
            disabled={isDisabled}
            aria-pressed={value === kegLocation}
            key={value}
          >
            <LocationMarkerIcon
              className={`w-4 h-4 ${value === kegLocation ? 'text-white' : 'text-black dark:text-slate-200'}`}
            />
            <span
              className={[
                value === kegLocation ? 'text-white' : 'text-black dark:text-slate-200',
                'text-sm',
              ].join(' ')}
            >
              {value}
            </span>
          </button>
        ))}
      </div>
      <p className="text-xs mt-2 font-semibold text-red-500 dark:text-red-300">
        {getKegLocationDescription(kegLocation)}
      </p>
    </div>
  )
}

export default memo(KegLocationRadioCards)
